import img1 from './1.jpg'
import img2 from './2.jpeg'

const images = [img1, img2]

export { images }